<template>
    <div class="col-lg-12">
        <table-search-and-pagination
            :sub-title="`${lastYear} - ${today}`"
            :per-page="perPage"
            :table-data="receiptLogs"
            @perPageUpdated="$emit('perPageUpdated', $event)"
            @dataUpdated="queriedData = $event"
        >
            <receipt-logs-table
                v-if="receiptLogs"
                :receipt-logs="queriedData"
                :user-type="userType"
                :exclude-columns="['Customer']"
                :exclude-available-when-zero="excludeAvailableWhenZero"
                @changeExcludeAvailableWhenZero="changeExcludeAvailableWhenZero"
            />
        </table-search-and-pagination>
    </div>
</template>
<script>
import moment from "moment-timezone";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import ReceiptLogsTable from "src/modules/ReceiptLog/ReceiptLogs/_components/ReceiptLogsTable.vue";

export default {
    name: "CustomerReceiptLogs",
    components: {
        ReceiptLogsTable,
        TableSearchAndPagination,
    },
    props: {
        receiptLogs: {
            type: Array,
            required: true,
        },
        userType: {
            type: String,
            required: true,
        },
        perPage: {
            type: Number,
            required: true,
        },
        excludeAvailableWhenZero: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            queriedData: [],
        };
    },
    computed: {
        lastYear() {
            return moment().subtract(1, "years").format("MM/DD/YYYY");
        },
        today() {
            return moment().format("MM/DD/YYYY");
        },
    },
    methods: {
        changeExcludeAvailableWhenZero(value) {
            this.$emit("changeExcludeAvailableWhenZero", value);
        },
    },
};
</script>
